export default __webpack_public_path__ + "static/media/dashboard.93784405.png";